import { getPreviewVariables, VARIABLE_CATEGORIES, } from '@/helpers/consts';
export const getEmptyTemplate = () => ({
    status: '',
    logoUrl: '',
    subAccount: '',
    method: '',
    methodCode: '',
    emailType: '',
    sendFromName: '',
    replayToName: '',
    subject: '',
    headerContent: '',
    bodyContent: '',
    showAppointmentDescription: true,
    additionalText: '',
    showCancelButton: true,
    showModifyButton: true,
    footerContent: '',
    links: [],
});
export const getEmptyErrors = () => ({
    subject: '',
    headerContent: '',
    bodyContent: '',
    additionalText: '',
    footerContent: '',
});
export const EMAIL_TEMPLATE_FIELD_LIMITS = {
    subject: 500,
    headerContent: 500,
    bodyContent: 1000,
    additionalText: 1000,
    footerContent: 500,
};
export const MAX_TEST_EMAIL_RECIPIENTS = 5;
const TEST_RECIPIENT_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const isValidTestRecipientEmail = (email) => (TEST_RECIPIENT_EMAIL_PATTERN.test(email));
export const prepareEmailType = (type) => {
    if (!type) {
        return '';
    }
    if (type === 'cancellation') {
        return 'Cancellation';
    }
    return type.charAt(0).toUpperCase() + type.slice(1);
};
export const replacePreviewVariables = (value, locale, overrides = {}) => {
    const variables = {
        ...getPreviewVariables(locale),
        ...overrides,
    };
    return Object.keys(variables).reduce((result, key) => {
        const re = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
        return result.replace(re, variables[key]);
    }, value || '');
};
export const isVariableAvailableForCurrentMethod = (variable, method, methodCode) => {
    if (!variable.methods?.length) {
        return true;
    }
    const currentMethodValues = [
        methodCode,
        method,
    ]
        .filter(Boolean)
        .map(value => value.toLowerCase());
    return variable.methods.some(methodItem => currentMethodValues.includes(methodItem.toLowerCase()));
};
export const filterVariables = (variables, search) => {
    const normalizedSearch = search.trim().toLowerCase();
    if (!normalizedSearch) {
        return variables;
    }
    return variables.filter(variable => variable.name.toLowerCase().includes(normalizedSearch));
};
export const groupVariables = (variables) => {
    return VARIABLE_CATEGORIES
        .map(category => ({
        category,
        variables: variables.filter(variable => variable.category === category),
    }))
        .filter(group => group.variables.length);
};
